import * as React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {useLoaderData, useNavigate} from "react-router-dom";
import {Container, Button, CardHeader} from "@mui/material";
import closedChest from "../assets/fame.png";
import {format} from "date-fns";
import CardMedia from "@mui/material/CardMedia";
import dragon from "../assets/dragon.jpg";
import CardActions from "@mui/material/CardActions";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LoadingButton from "@mui/lab/LoadingButton";
import {useState} from "react";
import api from "../services/api";

export default function Adventures() {
    const adventures = useLoaderData();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

    const prepare = (adventure) => {
        setLoading(true)

        api()
            .games()
            .then(games => {
                if (games.length) {
                    navigate(`/games/${games[0].id}`)
                } else {
                    api()
                        .newGame({
                            name: adventure.name,
                            adventure_id: adventure.id
                        })
                        .then(game => navigate(`/games/${game.id}`))
                }
            })
            .finally(() => setLoading(false))
    };

    const play = (game) => {
        navigate('/games/' + game.id + "/play")
    }

    return (
        <>
            <Container maxWidth="sm" sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                alignContent: 'center',
                justifyItems: 'center',
                justifyContent: 'center'
            }}>
                <img src={closedChest} alt={'closed chest'} width={60}/>
                <Typography variant="h5" align="center" color="text.secondary" paragraph sx={{ ml: 1, mb: 0 }}>
                    Aventures
                </Typography>
            </Container>
            <Typography align="center" color="text.secondary" paragraph sx={{ mt: 1 }}>
                Choisissez une aventure ci-dessous.
            </Typography>
            <Grid container spacing={4} sx={{ pl: 2, pr: 2, pt: 1 }} alignItems="center" justify="center"
                  direction="column">
                {adventures.map((adventure) => {
                    return (
                        <Grid item key={adventure} xs={12} sm={6} md={4}>
                            <Card>
                                <CardHeader
                                    title={adventure.name}
                                    subheader={format(new Date('2023-03-22'), 'dd/MM/yyyy')}
                                />
                                <CardMedia
                                    component="img"
                                    height="194"
                                    src={dragon}
                                    alt="Dragon"
                                />
                                <CardActions style={{ justifyContent: 'space-between' }}>
                                    <LoadingButton onClick={() => prepare(adventure)} loading={loading}>
                                        <ManageHistoryIcon sx={{ mr: 1 }}/> Préparer
                                    </LoadingButton>
                                    <Button disabled={!adventure.games?.find(game => game.ready)}
                                            onClick={() => play(adventure.games.find(game => game.ready))}>
                                        <SportsEsportsIcon sx={{ mr: 1 }}/> Jouer
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
}
